export const Base64 = {
  encode(text: string) {
    const encoder = new TextEncoder()
    const bytes = encoder.encode(text)

    const binString = Array.from(bytes, (byte) =>
      String.fromCodePoint(byte),
    ).join('')

    return btoa(binString)
  },

  decode(base64: string) {
    const binString = atob(base64)

    const bytes = Uint8Array.from(binString, (m) => {
      const code = m.codePointAt(0)

      if (code !== undefined) {
        return code
      }

      throw new Error('Invalid character in base64 string')
    })

    const decoder = new TextDecoder()
    return decoder.decode(bytes)
  },
}
